export default "__VITE_ASSET__c1a3f61e__"